module.exports = __webpack_public_path__ + "media/images/lp/1/support-ashinaga3-pc-3926b0e9a58c2cc25738b5f82a489a69.png";